<template>
  <section class="min-h-screen grid-cols-8 md:grid">
    <section class="relative hidden min-h-screen md:block lg:col-span-5 md:col-span-4">
      <img :src="'images/Background_Login.png'" class="w-full h-full" :alt="urlImageAlt" cache />
      <div class="absolute top-10 left-12">
        <img :src="'/images/av_hrs_putih.png'" :alt="altImageLogo" class="lg:w-40 md:w-28" cache />
        <h1 class="mt-2 italic font-bold text-white text lg:text-xl">
          Manage Attadance, leave and payroll.
        </h1>
      </div>
    </section>
    <section
      class="flex flex-col justify-center min-h-screen px-10 py-5 md:py-0 md:px-14 lg:px-20 lg:col-span-3 md:col-span-4">
      <div class="w-full px-4 py-1 mt-10 rounded">
        <img src="../assets/av_hrs.png" class="block h-12 m-auto w-26" />
      </div>
      <p class="my-4 text-center md:my-8 opacity-70">
        Hai! <br />
        Login to your dashboard
      </p>
      <!-- <div class="mb-5">
        <Select
          label="Login as"
          class="flex-col"
          label_class="w-full mb-2 text-gray-400"
          :options="[
            'Mufidah Group',
            'Mufidah Terminal Print',
            'Mufidah Studio',
            'Mufidah Stationery',
            'Mufidah Babyshop',
            'UD Wahyu',
          ]"
          @change="changeAccount($event)"
        />
      </div> -->
      <div class="mb-5">
        <label class="text-sm text-gray-400">Email</label>
        <input type="text" placeholder="Enter Your Email"
          class="w-full mt-2 border outline-gray-600 focus:outline focus:outline-primary px-2 py-1.5 bg-white rounded"
          autofocus v-model="email" />
      </div>
      <div class="relative mb-5">
        <label class="text-sm text-gray-400">Password</label>
        <div class="relative">
          <input :type="showPassword ? 'text' : 'password'" placeholder="Enter Your Password"
            class="w-full border mt-2 outline-gray-600 focus:outline focus:outline-primary px-2 py-1.5 bg-white rounded"
            v-model="password" @keyup="detectCapsLock" />
          <font-awesome-icon v-if="showPassword" @click="showPassword = false" icon="fa-eye"
            class="text-gray-400 absolute right-4 top-[50%] -translate-y-[25%]" />
          <font-awesome-icon v-else @click="showPassword = true" icon="fa-eye-slash"
            class="text-gray-400 absolute right-4 top-[50%] -translate-y-[25%]" />
        </div>
        <div
          class="absolute inset-x-0 z-10 px-2 py-1 mt-2 text-sm text-gray-100 duration-300 bg-gray-400 rounded tooltip top-full md:w-1/2"
          :class="capslockOn ? 'opacity-100' : 'opacity-0'">
          Caps Lock is On!
        </div>
      </div>
      <Button class="bg-dodgerblue mb-2.5 text-white py-2 h-9 text-sm rounded-sm relative" @click="handleLoginCompany"
        :disabled="loading">
        <Loading dotColor="white" class="py-1" v-if="loading" />
        <template v-else>Login</template>
      </Button>
      <!-- <Button class="py-2 text-sm text-white bg-gray-400 rounded-sm"
        >Register
      </Button> -->
      <div class="flex justify-between mt-3">
        <div>
          <input type="checkbox" class="mr-2" />
          <label class="text-sm">Remember me</label>
        </div>
        <router-link to="/forgot-password" class="text-sm underline text-dodgerblue"><font-awesome-icon icon="fa-lock"
            class="mr-2" />Forgot
          password</router-link>
      </div>
      <p class="mt-8 mb-5 text-sm text-center text-gray-400">
        Copyright Ⓒ {{ new Date().getFullYear() }} by ArmadaVision
      </p>
      <p class="text-gray-400 text-center mb-5 text-sm">
        <router-link to="/privacy-and-policy" class="text-primary text-sm">Privacy And Policy</router-link> or
        <router-link to="/supports" class="text-primary text-sm">Supports</router-link>
      </p>
    </section>
  </section>
</template>

<script>
import Button from "../components/Button.vue";
import { LoginSuperAPI, LoginAdminAPI } from "@/actions/login";
import Select from "@/components/Select/index.vue";
import CryptoJS from "crypto-js";
import { SECRET_KEY } from "@/config";
import Loading from "@/components/Loading.vue";
import { useToast } from "vue-toastification";

export default {
  name: "LoginPage",
  components: { Button, Select, Loading },
  data() {
    return {
      altImageLogo: "Logo avapps",
      urlImageAlt: "Backgound Login Image",
      login_as: "",
      email: "",
      password: "",
      loading: false,
      capslockOn: false,
      showPassword: false,
    };
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  methods: {
    detectCapsLock(event) {
      this.capslockOn =
        event.getModifierState && event.getModifierState("CapsLock");
    },
    encrypt(token) {
      const secret_key = SECRET_KEY;
      const ciphertext = CryptoJS.AES.encrypt(token, secret_key);
      return ciphertext.toString();
    },
    validationResponse(response) {
      if (response?.status === 200) {
        const { token, accountData } = response?.data;
        const encryptedToken = this.encrypt(token);
        this.$store.state.isLoggedIn = true;
        // this.toast.success(response?.data?.message);
        this.$store.commit("setToken", encryptedToken);
        localStorage.setItem("isLoggedIn", true);
        localStorage.setItem("token", encryptedToken);
        localStorage.setItem("accountData", JSON.stringify(accountData));
        this.$router.push("/");
      } else {
        if (response?.data?.message) {
          this.toast.error(response?.data?.message);
        }
        this.loading = false;
      }
    },
    async handleLoginCompany() {
      this.loading = true;
      const { email, password } = this;
      // if (!this.login_as) {
      //   return alert("Select role to Login");
      // }
      // if (this.login_as === "Mufidah Group") {
      //   const response = await LoginSuperAPI({ email, password });
      //   console.log(response);
      //   this.validationResponse(response);
      // } else if (this.login_as !== "Mufidah Group") {
      const response = await LoginAdminAPI({ email, password });
      this.validationResponse(response);
      this.loading = false;
      // }
    },
  },
};
</script>

<style scoped>
.tooltip::before {
  content: "";
  display: block;
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 8px;
  border-style: solid;
  border-color: transparent transparent #979797 transparent;
}
</style>
